import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface LoadingStateProps {
  message?: string;
  page?: string;
  backgroundColor?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ 
  message, 
  page = 'data',
  backgroundColor = 'bg-[#1a1a1a]'
}) => {
  const displayMessage = message || `Loading ${page}...`;

  return (
    <div className={`flex items-center justify-center min-h-[92vh] ${backgroundColor}`}>
      <div className="text-center">
        {/* Lottie Animation */}
        <div className="w-48 h-48 mx-auto mb-4">
          <DotLottieReact
            src="https://lottie.host/ba179149-4825-49a0-8d2b-2bff787478d0/9mFTTEa0AC.lottie"
            loop
            autoplay
          />
        </div>
        <div className="text-white text-md italic font-normal">{displayMessage}</div>
      </div>
    </div>
  );
};

export default LoadingState;
